import React, { useEffect, useState } from "react";
import Head from "../layout/head/Head";
import Content from "../layout/content/Content";
import Select from "react-select";
import { Puff } from "react-loader-spinner";

import {
  Card,
  Input,
  CardTitle,
  Badge,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  Row,
  Col,
  PreviewCard,
  BlockBetween,
} from "../components/Component";
import { useNavigate } from "react-router-dom";
import {
  fetchAPMs,
  fetchAPMsToggle,
  fetchAllCountries,
  fetchBannerData,
  fetchCountries,
  fetchDefaultSearchResult,
  fetchNextAPMs,
  fetchService,
  fetchType,
  searchTypes,
} from "../utils/api";
import services from "../utils/services";
import { CustomHeader } from "../layout/header";

const Homepage = () => {
  const [loader, setLoader] = useState(true);
  const [countries, setCountries] = useState([]);
  const [types, setTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [typesdata, setTypesdata] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [serviceData, setServiceData] = useState(services);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [logoData, setLogoData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCounts, setTotalCounts] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterName, setFilterName] = useState(null);
  const pageLimit = 3;

  const [randomServices, setRandomServices] = useState([]);
  const [checkboxStates, setCheckboxStates] = useState([]);
  const [cart, setCart] = useState(0);
  const [cartData, setCartData] = useState([]);

  const handleToggle = (value, data, index) => {
    const updatedStates = [...checkboxStates];
    updatedStates[index] = !updatedStates[index];
    setCheckboxStates(updatedStates);
    console.log(checkboxStates, index);
    if (updatedStates[index]) {
      setCart(cart + 1); // Increment the cart count
      const updatedCartData = [...cartData, data]; // Add the entire data object to cartData
      setCartData(updatedCartData);
      localStorage.setItem("cartValue", cart + 1);
      localStorage.setItem("cartDataStore", JSON.stringify(updatedCartData)); // Store the cart data in localStorage
    } else {
      setCart(cart - 1); // Decrement the cart count
      const updatedCartData = cartData.filter((item) => item.id !== data.id); // Remove the item with the matching id
      setCartData(updatedCartData);
      localStorage.setItem("cartValue", cart - 1);
      localStorage.setItem("cartDataStore", JSON.stringify(updatedCartData)); // Update the cart data in localStorage
    }
    console.log(updatedStates);
  };

  const getServiceData = () => {
    // fetchService()
    //   .then((res) => {
    const serviceFormate = serviceData?.map((type) => ({
      value: type.name, // Use type code as value
      label: type.name, // Use common name as label
    }));

    const filteredData = serviceFormate.filter(
      (item) => item.value !== "APMs" && item.value !== "Payment Gateways"
    );
    // const shuffled = filteredData?.sort(() => 0.5 - Math.random()); // Shuffle the array
    setRandomServices(filteredData);

    setServiceData(serviceFormate);

    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  };

  const getTypeData = () => {
    fetchType()
      .then((res) => {
        const typeFormate = res.data?.map((type) => ({
          value: type.category, // Use type code as value
          label: type.category, // Use common name as label
        }));

        setTypesdata(typeFormate);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Calculate the current page group based on the current page and limit
  const startPage = Math.max(1, page - Math.floor(pageLimit / 2)); // start page shifts as the user navigates
  const endPage = Math.min(totalCounts, startPage + pageLimit - 1);

  const handlePageClick = (page) => {
    setPage(page);
    if (filterName == "apms") {
      getCountryData(page);
    } else if (filterName == "country") {
      getCountryProfile(page);
    } else if (filterName == "apm_search") {
      setLoader(true);
      let newpage = page;
      searchTypes({ searchValue, newpage })
        .then((res) => {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          setFilterName("apm_search");
          setCountryData(res?.data?.results);
          checkToggleValues(res?.data?.results);
        })
        .catch((error) => {
          console.log(error);
          setTimeout(() => {
            setLoader(false);
          }, 1000);
        });
    } else {
      setLoader(true);
      const selectedCountryNames =
        selectedCountries?.length > 0
          ? selectedCountries.map((option) => option.label)
          : "";

      const selectedTypesNames = types?.map((option) => option.label);
      const selectedCategoryNames =
        categories?.length > 0 ? categories?.map((option) => option.label) : "";
      const hasAPMs = selectedTypesNames.includes("APMs");
      const hasPaymentGateways =
        selectedTypesNames.includes("Payment Gateways");

      if (selectedCountryNames) {
        fetchCountries({
          selectedCountryNames,
          selectedTypesNames,
          selectedCategoryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            let all_values = [];
            const totalCountSum = res?.data?.reduce((sum, item) => {
              return sum + item.top_apm_providers.total_count;
            }, 0);
            setTotalCounts(Math.floor(totalCountSum / 18) + 1);

            const top_apms = res?.data?.map((item) => {
              all_values = [
                ...all_values,
                ...item?.top_apm_providers.apm_providers,
              ];
              return item?.top_apm_providers.apm_providers;
            });

            all_values = Array.from(
              new Map(all_values.map((item) => [item.name, item])).values()
            );

            setCountryData(() => {
              return shuffle(all_values);
            });
            checkToggleValues(all_values);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        if (hasAPMs || hasPaymentGateways) {
          setLoader(true);
          fetchAPMs({ selectedTypesNames, selectedCategoryNames, page })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
              let all_values = [];
              all_values = Array.from(
                new Map(
                  res?.data?.results.map((item) => [item.name, item])
                ).values()
              );

              setCountryData(all_values);
              checkToggleValues(all_values);
            })
            .catch((error) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              console.log(error);
            });
        } else {
          getCountryProfile(page);
        }
      }
    }
    // Trigger a function to fetch new data if necessary
  };

  const handleNextGroup = () => {
    if (page < totalCounts) {
      setPage(page + 1);
      if (filterName == "apms") {
        getCountryData(page + 1);
      } else if (filterName == "country") {
        getCountryProfile(page + 1);
      } else if (filterName == "apm_search") {
        setLoader(true);
        let newpage = page + 1;
        searchTypes({ searchValue, newpage })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setFilterName("apm_search");
            setCountryData(res?.data?.results);
            checkToggleValues(res?.data?.results);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        setLoader(true);
        const selectedCountryNames =
          selectedCountries?.length > 0
            ? selectedCountries.map((option) => option.label)
            : "";
        const selectedTypesNames = types?.map((option) => option.label);
        const selectedCategoryNames =
          categories?.length > 0
            ? categories?.map((option) => option.label)
            : "";
        const hasAPMs = selectedTypesNames.includes("APMs");
        const hasPaymentGateways =
          selectedTypesNames.includes("Payment Gateways");

        if (selectedCountryNames) {
          const newPage = page + 1;
          fetchCountries({
            selectedCountryNames,
            selectedTypesNames,
            selectedCategoryNames,
            newPage,
          })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              let all_values = [];
              const totalCountSum = res?.data?.reduce((sum, item) => {
                return sum + item.top_apm_providers.total_count;
              }, 0);
              setTotalCounts(Math.floor(totalCountSum / 18) + 1);

              const top_apms = res?.data?.map((item) => {
                all_values = [
                  ...all_values,
                  ...item?.top_apm_providers.apm_providers,
                ];
                return item?.top_apm_providers.apm_providers;
              });

              all_values = Array.from(
                new Map(all_values.map((item) => [item.name, item])).values()
              );

              setCountryData(() => {
                return shuffle(all_values);
              });
              checkToggleValues(all_values);
            })
            .catch((error) => {
              console.log(error);
              setTimeout(() => {
                setLoader(false);
              }, 1000);
            });
        } else {
          if (hasAPMs || hasPaymentGateways) {
            setLoader(true);
            fetchAPMs({ selectedTypesNames, selectedCategoryNames, page })
              .then((res) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
                let all_values = [];
                all_values = Array.from(
                  new Map(
                    res?.data?.results.map((item) => [item.name, item])
                  ).values()
                );

                setCountryData(all_values);
                checkToggleValues(all_values);
              })
              .catch((error) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                console.log(error);
              });
          } else {
            getCountryProfile(page + 1);
          }
        }
      }
    }
  };

  const handlePrevGroup = () => {
    if (page > 1) {
      setPage(page - 1);
      if (filterName == "apms") {
        getCountryData(page - 1);
      } else if (filterName == "country") {
        getCountryProfile(page - 1);
      } else if (filterName == "apm_search") {
        setLoader(true);
        let newpage = page - 1;
        searchTypes({ searchValue, newpage })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setFilterName("apm_search");
            setCountryData(res?.data?.results);
            checkToggleValues(res?.data?.results);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        setLoader(true);
        const selectedCountryNames =
          selectedCountries?.length > 0
            ? selectedCountries.map((option) => option.label)
            : "";
        const selectedTypesNames = types?.map((option) => option.label);
        const selectedCategoryNames =
          categories?.length > 0
            ? categories?.map((option) => option.label)
            : "";
        const hasAPMs = selectedTypesNames.includes("APMs");
        const hasPaymentGateways =
          selectedTypesNames.includes("Payment Gateways");

        const newPage = page - 1;
        if (selectedCountryNames) {
          fetchCountries({
            selectedCountryNames,
            selectedTypesNames,
            selectedCategoryNames,
            newPage,
          })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              let all_values = [];
              const totalCountSum = res?.data?.reduce((sum, item) => {
                return sum + item.top_apm_providers.total_count;
              }, 0);
              setTotalCounts(Math.floor(totalCountSum / 18) + 1);

              const top_apms = res?.data?.map((item) => {
                all_values = [
                  ...all_values,
                  ...item?.top_apm_providers.apm_providers,
                ];
                return item?.top_apm_providers.apm_providers;
              });

              all_values = Array.from(
                new Map(all_values.map((item) => [item.name, item])).values()
              );

              setCountryData(() => {
                return shuffle(all_values);
              });
              checkToggleValues(all_values);
            })
            .catch((error) => {
              console.log(error);
              setTimeout(() => {
                setLoader(false);
              }, 1000);
            });
        } else {
          if (hasAPMs || hasPaymentGateways) {
            setLoader(true);
            fetchAPMs({ selectedTypesNames, selectedCategoryNames, newPage })
              .then((res) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
                let all_values = [];
                all_values = Array.from(
                  new Map(
                    res?.data?.results.map((item) => [item.name, item])
                  ).values()
                );

                setCountryData(all_values);
                checkToggleValues(all_values);
              })
              .catch((error) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                console.log(error);
              });
          } else {
            getCountryProfile(page - 1);
          }
        }
      }
    }
  };

  // Render page numbers dynamically
  const renderPageNumbers = () => {
    let pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PaginationItem key={i} active={page === i}>
          <PaginationLink href="#" onClick={() => handlePageClick(i)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return pages;
  };

  const navigate = useNavigate();

  const handleSearchTpes = (e) => {
    const searchValue = e
    setSearchValue(searchValue);
    const newpage = 1;
    console.log("serach value ", searchValue)
    if (searchValue?.length > 2) {
      console.log("in if cond .....................")
      setLoader(true);
      if (selectedCountries.length == 0 && types.length == 0) {
        fetchDefaultSearchResult(searchValue).then((res) => {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          setCountryData(res?.data?.results);
          checkToggleValues(res?.data?.results);
        }).catch((error) => {
          console.log(error);
          setTimeout(() => {
            setLoader(false);
          }, 1000);
        });
      } else {
        console.log("in here-------------->>>>>");
        let typeString = "";
        if (types.length > 0) {
          for (let i = 0; i < types.length; i++) {
            if (i !== types.length - 1)
              typeString += types[i].value + ",";
            else
              typeString += types[i].value;
          }
        }
        searchTypes({ searchValue, typeString, newpage })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setFilterName("apm_search");
            setCountryData(res?.data?.results);
            checkToggleValues(res?.data?.results);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      }
    } else {
      setLoader(true);
      const selectedCountryNames =
        selectedCountries?.length > 0
          ? selectedCountries.map((option) => option.label)
          : "";
      const selectedTypesNames = types?.map((option) => option.label);
      const selectedCategoryNames =
        categories?.length > 0 ? categories?.map((option) => option.label) : "";
      const hasAPMs = selectedTypesNames.includes("APMs");
      const hasPaymentGateways =
        selectedTypesNames.includes("Payment Gateways");

      if (selectedCountryNames) {
        fetchCountries({
          selectedCountryNames,
          selectedTypesNames,
          selectedCategoryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            let all_values = [];
            const totalCountSum = res?.data?.reduce((sum, item) => {
              return sum + item.top_apm_providers.total_count;
            }, 0);
            setTotalCounts(Math.floor(totalCountSum / 18) + 1);

            const top_apms = res?.data?.map((item) => {
              all_values = [
                ...all_values,
                ...item?.top_apm_providers.apm_providers,
              ];
              return item?.top_apm_providers.apm_providers;
            });

            all_values = Array.from(
              new Map(all_values.map((item) => [item.name, item])).values()
            );

            setCountryData(all_values);
            checkToggleValues(all_values);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        if (hasAPMs || hasPaymentGateways) {
          setLoader(true);
          fetchAPMs({ selectedTypesNames, selectedCategoryNames, page })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
              let all_values = [];
              all_values = Array.from(
                new Map(
                  res?.data?.results.map((item) => [item.name, item])
                ).values()
              );

              setCountryData(all_values);
              checkToggleValues(all_values);
            })
            .catch((error) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              console.log(error);
            });
        } else {
          getCountryProfile(1);
        }
      }
    }
  };

  const handleNavigate = (
    country_name,
    type_name,
    category,
    id,
    service__name,
    togal,
    payment
  ) => {
    const selectedCountryNames =
      selectedCountries?.length > 0
        ? selectedCountries.map((option) => option.label)
        : "";

    const selectedTypesNames = types?.map((option) => option.label);
    const TypeName = selectedTypesNames ? selectedTypesNames : "APMs";
    const selectedCategoryNames =
      categories?.length > 0 ? categories?.map((option) => option.label) : "";
    const new_type = country_name ? "" : TypeName;
    const body = {
      country: country_name ? country_name : selectedCountryNames,
      type: type_name ? selectedTypesNames : "",
      category: category ? category : "",
      id: id,
      service__name: service__name ? service__name : "",
      filterName: filterName,
      selectCategory: selectedCategoryNames,
      page: page,
      selectCountries: selectedCountryNames,
      payment: payment ? payment : "",
    };
    const cartData = {
      togalCount: cart,
      togal: togal,
    };

    localStorage.setItem("filter", JSON.stringify(body));

    navigate(`/${type_name ? type_name : country_name}`, {
      state: body,
      cartbody: cartData,
    });
  };

  const handleClear = () => {
    setSelectedCountries([]);
    setTypes([]);
    setCategories([]);
    getCountryProfile(1);
  };

  const shuffle = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const handleCountryChange = (selectedOptions) => {
    setFilterName("filter");
    setPage(1);
    let page = 1;
    setSelectedCountries(selectedOptions || []);

    const selectedTypesNames =
      types?.length > 0 ? types?.map((option) => option.label) : "";

    const selectedCategoryNames =
      categories?.length > 0 ? categories?.map((option) => option.label) : "";
    const selectedCountryNames = selectedOptions
      ? selectedOptions.map((option) => option.label)
      : "";
    if (selectedOptions && selectedOptions.length > 0) {
      const selectedCountryNames = selectedOptions.map(
        (option) => option.label
      );

      const hasAPMs = selectedTypesNames?.includes("APMs");
      const hasPaymentGateways =
        selectedTypesNames?.includes("Payment Gateways");
      if (hasAPMs || hasPaymentGateways) {
        setLoader(true);
        fetchCountries({
          selectedCountryNames,
          selectedTypesNames,
          selectedCategoryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            let all_values = [];
            const totalCountSum = res?.data?.reduce((sum, item) => {
              return sum + item.top_apm_providers.total_count;
            }, 0);
            setTotalCounts(Math.floor(totalCountSum / 18) + 1);

            const top_apms = res?.data?.map((item) => {
              all_values = [
                ...all_values,
                ...item?.top_apm_providers.apm_providers,
              ];
              return item?.top_apm_providers.apm_providers;
            });

            all_values = Array.from(
              new Map(all_values.map((item) => [item.name, item])).values()
            );

            setCountryData(() => {
              return shuffle(all_values);
            });
            checkToggleValues(all_values);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        setLoader(true);
        fetchCountries({
          selectedCountryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setTotalCounts(1);
            setCountryData(res?.data);
            checkToggleValues(res?.data);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      }
    } else {
      setLoader(true);
      const hasAPMs = selectedTypesNames?.includes("APMs");
      const hasPaymentGateways =
        selectedTypesNames?.includes("Payment Gateways");
      if (hasAPMs || hasPaymentGateways) {
        setLoader(true);
        fetchAPMs({ selectedTypesNames, selectedCategoryNames, page })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
            let all_values = [];
            all_values = Array.from(
              new Map(
                res?.data?.results.map((item) => [item.name, item])
              ).values()
            );

            setCountryData(all_values);
            checkToggleValues(all_values);
          })
          .catch((error) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            console.log(error);
          });
      } else {
        getCountryProfile(1);
      }
    }
  };

  const handleServiceChange = (selectedOptions) => {
    setFilterName("filter");
    setPage(1);
    // Update state with selected options or set to empty array if no options are selected
    setTypes(selectedOptions || []);

    const selectedCountryNames =
      selectedCountries?.length > 0
        ? selectedCountries.map((option) => option.label)
        : "";
    const selectedCategoryNames =
      categories?.length > 0 ? categories?.map((option) => option.label) : "";
    if (selectedOptions && selectedOptions.length > 0) {
      const selectedTypesNames = selectedOptions.map((option) => option.label);

      const hasAPMs = selectedTypesNames?.includes("APMs");
      const hasPaymentGateways =
        selectedTypesNames?.includes("Payment Gateways");

      if (selectedCountryNames) {
        if (hasAPMs || hasPaymentGateways) {
          setLoader(true);
          fetchCountries({
            selectedCountryNames,
            selectedTypesNames,
            selectedCategoryNames,
            page,
          })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              let all_values = [];
              const totalCountSum = res?.data?.reduce((sum, item) => {
                return sum + item.top_apm_providers.total_count;
              }, 0);
              setTotalCounts(Math.floor(totalCountSum / 18) + 1);

              const top_apms = res?.data?.map((item) => {
                all_values = [
                  ...all_values,
                  ...item?.top_apm_providers.apm_providers,
                ];
                return item?.top_apm_providers.apm_providers;
              });

              all_values = Array.from(
                new Map(all_values.map((item) => [item.name, item])).values()
              );

              setCountryData(all_values);
              checkToggleValues(all_values);
            })
            .catch((error) => {
              console.log(error);
              setTimeout(() => {
                setLoader(false);
              }, 1000);
            });
        } else {
          getCountryProfile(1);
        }
      } else {
        if (hasAPMs || hasPaymentGateways) {
          setLoader(true);
          fetchAPMs({ selectedTypesNames, selectedCategoryNames, page })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
              let all_values = [];
              all_values = Array.from(
                new Map(
                  res?.data?.results.map((item) => [item.name, item])
                ).values()
              );

              setCountryData(all_values);
              checkToggleValues(all_values);
            })
            .catch((error) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              console.log(error);
            });
        } else {
          getCountryProfile(1);
        }
      }
    } else {
      setFilterName("country");
      if (selectedCountryNames) {
        setLoader(true);
        fetchCountries({
          selectedCountryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setCountryData(res?.data);
            checkToggleValues(res?.data);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        getCountryProfile(1);
      }
    }
  };

  const handleCategoryChange = (selectedOptions) => {
    setFilterName("filter");
    setCategories(selectedOptions || []);
    setPage(1);

    const selectedCountryNames =
      selectedCountries?.length > 0
        ? selectedCountries.map((option) => option.label)
        : "";

    const selectedTypesNames = types?.map((option) => option.label);
    if (selectedOptions && selectedOptions.length > 0) {
      const selectedCategoryNames = selectedOptions?.map(
        (option) => option.label
      );
      setLoader(true);
      if (selectedCountryNames) {
        fetchCountries({
          selectedCountryNames,
          selectedTypesNames,
          selectedCategoryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            let all_values = [];
            const totalCountSum = res?.data?.reduce((sum, item) => {
              return sum + item.top_apm_providers.total_count;
            }, 0);
            setTotalCounts(Math.floor(totalCountSum / 18) + 1);

            const top_apms = res?.data?.map((item) => {
              all_values = [
                ...all_values,
                ...item?.top_apm_providers.apm_providers,
              ];
              return item?.top_apm_providers.apm_providers;
            });

            all_values = Array.from(
              new Map(all_values.map((item) => [item.name, item])).values()
            );

            setCountryData(all_values);
            checkToggleValues(all_values);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        const hasAPMs = selectedTypesNames.includes("APMs");
        const hasPaymentGateways =
          selectedTypesNames.includes("Payment Gateways");
        if (hasAPMs || hasPaymentGateways) {
          setLoader(true);
          fetchAPMs({ selectedTypesNames, selectedCategoryNames, page })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
              let all_values = [];
              all_values = Array.from(
                new Map(
                  res?.data?.results.map((item) => [item.name, item])
                ).values()
              );

              setCountryData(all_values);
              checkToggleValues(all_values);
            })
            .catch((error) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              console.log(error);
            });
        } else {
          getCountryProfile(1);
        }
      }
    } else {
      setLoader(true);
      if (selectedCountryNames) {
        fetchCountries({
          selectedCountryNames,
          page,
        })
          .then((res) => {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            setCountryData(res?.data);
            checkToggleValues(res?.data);
          })
          .catch((error) => {
            console.log(error);
            setTimeout(() => {
              setLoader(false);
            }, 1000);
          });
      } else {
        const hasAPMs = selectedTypesNames.includes("APMs");
        const hasPaymentGateways =
          selectedTypesNames.includes("Payment Gateways");
        if (hasAPMs || hasPaymentGateways) {
          setLoader(true);
          fetchAPMs({ selectedTypesNames, page })
            .then((res) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
              let all_values = [];
              all_values = Array.from(
                new Map(
                  res?.data?.results.map((item) => [item.name, item])
                ).values()
              );

              setCountryData(all_values);
              checkToggleValues(all_values);
            })
            .catch((error) => {
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              console.log(error);
            });
        } else {
          getCountryProfile(1);
        }
      }
    }
  };

  useEffect(() => {
    console.log(page);
    getServiceData();
    getTypeData();
    getCountyFlag();
    bannerData();
    const storedCart = localStorage.getItem("cartValue");
    const storedCartData = localStorage.getItem("cartDataStore");

    if (storedCart) {
      setCart(parseInt(storedCart, 10)); // Initialize cart count
    }
    if (storedCartData) {
      setCartData(JSON.parse(storedCartData)); // Initialize cartData array
    }

    const storedData = localStorage.getItem("filter");

    if (storedData) {
      const parsedData = JSON.parse(storedData);

      // Set the states for countries, types, and categories if available
      if (parsedData.country && Array.isArray(parsedData.country)) {
        const formattedCountries = parsedData.country.map((country) => ({
          label: country,
          value: country,
        }));
        setSelectedCountries(formattedCountries);
      }
      if (parsedData?.filterName) {
        setFilterName(parsedData.filterName);
      }

      if (parsedData?.togalCount) {
        setCart(parsedData.togalCount);
      }

      if (parsedData?.page) {
        setPage(parsedData.page);
      }

      if (
        (parsedData.type && Array.isArray(parsedData.type)) ||
        parsedData.category ||
        parsedData?.page ||
        (parsedData.selectCategory &&
          Array.isArray(parsedData.selectCategory)) ||
        (parsedData.country && Array.isArray(parsedData.country)) ||
        (parsedData?.selectCountries &&
          Array.isArray(parsedData.selectCountries))
      ) {
        const formattedTypes =
          parsedData.type?.length > 0
            ? parsedData.type?.map((type) => ({
                label: type,
                value: type,
              }))
            : "";
        setTypes(formattedTypes);
        const formattedCategory = {
          label: parsedData.category,
          value: parsedData.category,
        };
        setPage(parsedData.page);
        const page = parsedData.page;
        const selectCategory =
          parsedData?.selectCategory?.length > 0
            ? parsedData.selectCategory?.map((type) => ({
                label: type,
                value: type,
              }))
            : "";
        setCategories(selectCategory);
        const selectedTypesNames =
          formattedTypes?.length > 0
            ? formattedTypes?.map((option) => option.label)
            : "";
        const selectedCategoryNames =
          selectCategory?.length > 0
            ? selectCategory?.map((option) => option.label)
            : "";
        const formattedCountries =
          parsedData?.selectCountries?.length > 0
            ? parsedData?.selectCountries?.map((country) => ({
                label: country,
                value: country,
              }))
            : "";
        setSelectedCountries(formattedCountries);
        const selectedCountryNames =
          formattedCountries?.length > 0
            ? formattedCountries?.map((option) => option.label)
            : "";

        if (selectedTypesNames) {
          if (selectedCountryNames) {
            fetchCountries({
              selectedCountryNames,
              selectedTypesNames,
              selectedCategoryNames,
              page,
            })
              .then((res) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                let all_values = [];
                const totalCountSum = res?.data?.reduce((sum, item) => {
                  return sum + item.top_apm_providers.total_count;
                }, 0);
                setTotalCounts(Math.floor(totalCountSum / 18) + 1);

                const top_apms = res?.data?.map((item) => {
                  all_values = [
                    ...all_values,
                    ...item?.top_apm_providers.apm_providers,
                  ];
                  return item?.top_apm_providers.apm_providers;
                });

                all_values = Array.from(
                  new Map(all_values.map((item) => [item.name, item])).values()
                );

                setCountryData(all_values);
                checkToggleValues(all_values);
              })
              .catch((error) => {
                console.log(error);
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
              });
          } else {
            fetchAPMs({
              selectedTypesNames,
              selectedCategoryNames,
              page,
            })
              .then((res) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
                let all_values = [];
                all_values = Array.from(
                  new Map(
                    res?.data?.results.map((item) => [item.name, item])
                  ).values()
                );

                setCountryData(all_values);
                checkToggleValues(all_values);
              })
              .catch((error) => {
                console.log(error);
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
              });
          }
        } else {
          if (selectedCountryNames) {
            fetchCountries({
              selectedCountryNames,
              selectedTypesNames,
              selectedCategoryNames,
              page,
            })
              .then((res) => {
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
                let all_values = [];
                const totalCountSum = res?.data?.reduce((sum, item) => {
                  return sum + item.top_apm_providers.total_count;
                }, 0);
                setTotalCounts(Math.floor(totalCountSum / 18) + 1);

                const top_apms = res?.data?.map((item) => {
                  all_values = [
                    ...all_values,
                    ...item?.top_apm_providers.apm_providers,
                  ];
                  return item?.top_apm_providers.apm_providers;
                });

                all_values = Array.from(
                  new Map(all_values.map((item) => [item.name, item])).values()
                );

                setCountryData(all_values);
                checkToggleValues(all_values);
              })
              .catch((error) => {
                console.log(error);
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
              });
          } else {
            getCountryProfile(parsedData?.page);
            setTypes([]);
          }
        }
      } else {
        getCountryProfile(1);
        setTypes([]);
      }

      // if (parsedData.category) {
      //   const formattedCategory = {
      //     label: parsedData.category,
      //     value: parsedData.category,
      //   };
      //   setCategories(formattedCategory);
      // }
    } else {
      getCountryProfile(1);
    }

    localStorage.removeItem("filter");
  }, []);

  useEffect(() => {
    console.log(types, searchValue)
    if (types.length > 0 && searchValue.length > 2) {
      handleSearchTpes(searchValue)
    }
  }, [types])

  const getCountyFlag = () => {
    fetch("https://restcountries.com/v3.1/all")
      .then((response) => response.json())
      .then((data) => {
        // Format the data for react-select
        const formattedData = data
          .map((country) => ({
            value: country.cca2, // Use country code as value
            label: country.name.common, // Use common name as label
            flag: country.flags?.png, // Use the PNG flag URL
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCountries(formattedData);
      });
  };

  const CustomOption = ({ innerRef, innerProps, data }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{ display: "flex", alignItems: "center", justifyContent: "left" }}
    >
      <img
        src={data.flag}
        alt={data.label}
        style={{ width: "20px", marginRight: "10px" }}
      />
      {data.label}
    </div>
  );

  const bannerData = () => {
    fetchBannerData()
      .then((res) => {
        setLogoData(res?.data?.[0]);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  };

  const getCountryData = (page) => {
    setLoader(true);
    const selectedTypesNames = "APMs";
    fetchAPMs({ selectedTypesNames, page })
      .then((res) => {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
        let all_values = [];
        all_values = Array.from(
          new Map(res?.data?.results.map((item) => [item.name, item])).values()
        );

        setCountryData(all_values);
        checkToggleValues(all_values);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  };

  const getCountryProfile = (page) => {
    setLoader(true);
    fetchAllCountries(page)
      .then((res) => {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        setTotalCounts(Math.floor(res?.data?.count / 18) + 1);
        const results = res.data?.results || [];
        setCountryData(results);
        checkToggleValues(results);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        });
      });
  };

  const checkToggleValues = (results) => {
    const storedCartData = localStorage.getItem("cartDataStore");

    const updatedCheckboxStates = results.map((item) =>
      JSON.parse(storedCartData).some((cartItem) => cartItem.id === item.id)
    );
    setCheckboxStates(updatedCheckboxStates);
  };

  const handleCheckout = () => {
    navigate("/cart");
  };

  // Get the first two elements

  return (
    <>
      <Head title="Homepage"></Head>
      <div
        className="banner_bg_image"
        style={{ background: `${logoData?.color ? logoData?.color : "#fff"}` }}
      >
        <Content>
          <CustomHeader
            cart={cart}
            logoData={logoData}
            showLogo={true}
            handleCheckout={handleCheckout}
          />
          <Block>
            <Row>
              <Col xxl="12">
                <Row className="g-gs">
                  <Col lg="12" xxl="12">
                    <PreviewCard className="preview_card">
                      <Row>
                        <Col lg={5}>
                          <div className="form-control-wrap">
                            <div className="form-icon form-icon-left">
                              <Icon name="search" />
                            </div>
                            <Input
                              name="searchValue"
                              value={searchValue}
                              onChange={(e) => {
                                handleSearchTpes(e.target.value);
                              }}
                              placeholder="Search"
                              type="text"
                              className="input_font"
                            />
                          </div>
                        </Col>
                        {/* <Col lg={8}> */}
                        {/* <Row> */}
                        <Col lg="2">
                          <div className="form-control-select">
                            <Select
                              placeholder="Country"
                              className={`react-select-container input_font`}
                              classNamePrefix="react-select"
                              components={{ Option: CustomOption }}
                              closeMenuOnSelect={false}
                              options={countries}
                              isMulti
                              onChange={handleCountryChange}
                              value={selectedCountries}
                            />
                            {/* <RSelect
                            placeholder="Country"
                            closeMenuOnSelect={false}
                            isMulti
                            customOption={CustomOption}
                            options={countries}
                          /> */}
                          </div>
                        </Col>
                        <Col lg="2">
                          <div className="form-control-select">
                            <Select
                              placeholder="Services"
                              closeMenuOnSelect={false}
                              onChange={handleServiceChange}
                              className={`react-select-container input_font`}
                              classNamePrefix="react-select"
                              options={serviceData}
                              isMulti
                              value={types}
                            />
                          </div>
                        </Col>
                        {types?.length > 0
                          ? types?.slice(0, 1)?.map((type, i) => {
                              if (type.value == "APMs") {
                                return (
                                  <>
                                    <Col lg="2" key={i}>
                                      <div className="form-control-select">
                                        <Select
                                          placeholder="Category"
                                          closeMenuOnSelect={false}
                                          onChange={handleCategoryChange}
                                          className={`react-select-container input_font`}
                                          classNamePrefix="react-select"
                                          options={typesdata}
                                          isMulti
                                          value={categories}
                                        />
                                      </div>
                                    </Col>
                                  </>
                                );
                              }
                            })
                          : ""}

                        <Col lg={1} className="text-end">
                          <Button
                            onClick={() => handleClear()}
                            type="button"
                            className="input_font"
                            style={{
                              background: "none",
                              color: "#e91e63",
                              fontSize: "18px",
                            }}
                          >
                            Reset
                          </Button>
                        </Col>
                        {/* </Row> */}
                        {/* </Col> */}
                      </Row>
                    </PreviewCard>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Block>
        </Content>
      </div>
      <Content style={{ background: "white !important" }}>
        {loader ? (
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Puff color="#1a2853" />
            </div>
          </>
        ) : (
          <Block>
            <Row className="g-gs">
              <Col lg={12} className="mt-3">
                <Row>
                  {countryData?.length > 0 ? (
                    countryData?.map((service, index) => {
                      const category = service?.category?.split(",");
                      return (
                        <Col lg={4} className="my-3" key={index}>
                          <Card className="card-bordered card-full py-3 px-4 text-left service_card">
                            {" "}
                            <div
                              onClick={() =>
                                handleNavigate(
                                  service?.country_name,
                                  service?.name,
                                  service?.category,
                                  service?.id,
                                  service?.service__name,
                                  checkboxStates[index],
                                  service?.service__name == "Payment Gateways"
                                    ? "Payment Gateways"
                                    : ""
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <div className="image_outer_section my-2">
                                {
                                  service?.service__name == 'Payment Gateways' && (!service?.apm_image && !service?.apm_logo) ? (
                                    <>
                                      <div className="px-4 py-2 border fw-bold fs-5 w-50 my-2 rounded" >
                                        {service?.name?.replace("_", " ")}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <img
                                        src={`${service?.image
                                          ? service?.image
                                          : `${service?.apm_image
                                            ? `${process.env.REACT_APP_API_URL}/media/${service?.apm_image?.replace(
                                              "http://backendmarketplace.ahrvoid.com/media",
                                              ""
                                            )}`
                                            : service?.apm_logo
                                          }`
                                          }`}
                                        width={100}
                                        className="card-img-top"
                                        alt=""
                                      />{" "}
                                    </>
                                  )
                                }
                              </div>{" "}
                              <CardTitle>
                                <h5 className="title">
                                  {service?.name?.replace("_", " ")}
                                  {service?.country_name?.replace("_", " ")}
                                </h5>
                              </CardTitle>{" "}
                              <p className="card-text">
                                {service?.compliance
                                  ? `${service?.compliance?.slice(0, 100)}..`
                                  : ""}
                                {service?.description
                                  ? `${service?.description?.slice(0, 100)}..`
                                  : ""}
                              </p>{" "}
                            </div>
                            <div className="row badges_toggles">
                              <div className="col-md-10">
                                {(service?.service__name ==
                                  "Payment Gateways" ||
                                  service?.service == "Payment Gateways") && (
                                  <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                                    Payment Gateways
                                  </Badge>
                                )}
                                {category?.map((item, i) => {
                                  return (
                                    <Badge
                                      key={i}
                                      className="btn btn-primary mx-1  badge_name py-1 my-1"
                                    >
                                      {item}
                                    </Badge>
                                  );
                                })}

                                {service?.country_name &&
                                  randomServices
                                    ?.sort(() => Math.random() - 0.5)
                                    ?.slice(0, 2)
                                    ?.map((item, i) => {
                                      return (
                                        <Badge
                                          key={i}
                                          className="btn btn-primary mx-1  badge_name py-1 my-1"
                                        >
                                          {item?.value}
                                        </Badge>
                                      );
                                    })}
                              </div>
                              <div className="col-md-2">
                                <div className="preview-block text-end">
                                  <div className="custom-control custom-switch">
                                    <div>
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={`customSwitch${index}`}
                                        checked={cartData.some(
                                          (item) => item.id === service.id
                                        )} // Check if service ID is in cartData
                                        onChange={() =>
                                          handleToggle(
                                            service.id,
                                            service,
                                            index
                                          )
                                        } // Handle toggle based on index
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor={`customSwitch${index}`}
                                      ></label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* <div className="col-md-4">
                                {!toggle ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    fill="currentColor"
                                    class="bi bi-toggle2-off"
                                    viewBox="0 0 16 16"
                                    onClick={() => setToggle(true)}
                                  >
                                    <path d="M9 11c.628-.836 1-1.874 1-3a4.98 4.98 0 0 0-1-3h4a3 3 0 1 1 0 6z" />
                                    <path d="M5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0 1A5 5 0 1 0 5 3a5 5 0 0 0 0 10" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    fill="currentColor"
                                    class="bi bi-toggle2-on"
                                    viewBox="0 0 16 16"
                                    onClick={() => setToggle(false)}
                                  >
                                    <path d="M7 5H3a3 3 0 0 0 0 6h4a5 5 0 0 1-.584-1H3a2 2 0 1 1 0-4h3.416q.235-.537.584-1" />
                                    <path d="M16 8A5 5 0 1 1 6 8a5 5 0 0 1 10 0" />
                                  </svg>
                                )}
                              </div> */}
                            </div>
                          </Card>
                        </Col>
                      );
                    })
                  ) : (
                    <>
                      <Col lg={12}>
                        <Card>
                          <div className="not_found">
                            <h4>
                              There are no results that fit that criteria.
                              <br />
                              Would you like to change that?
                            </h4>
                          </div>
                        </Card>
                      </Col>
                    </>
                  )}
                </Row>

                {countryData?.length > 0 && (
                  <div className="mt-5 mb-5 pagination_style">
                    <Pagination aria-label="Page navigation example">
                      {/* Previous group button */}
                      <PaginationItem disabled={page === 1}>
                        <PaginationLink
                          previous
                          href="#"
                          onClick={(ev) => {
                            ev.preventDefault();
                            handlePrevGroup();
                          }}
                        >
                          Prev
                        </PaginationLink>
                      </PaginationItem>

                      {/* Page number buttons */}
                      {renderPageNumbers()}

                      {/* Next group button */}
                      <PaginationItem disabled={page === totalCounts}>
                        <PaginationLink
                          next
                          href="#"
                          onClick={(ev) => {
                            ev.preventDefault();
                            handleNextGroup();
                          }}
                        >
                          Next
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </div>
                )}
              </Col>
            </Row>
          </Block>
        )}
      </Content>
    </>
  );
};
export default Homepage;
